import type { FC,useEffect} from "react"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useTheme } from "@mui/material/styles"
import {
  Box,
  Step,
  Stepper,
  IconButton,
  Button,
  ButtonGroup,
  Typography,
  Stack,
} from "../../../components/mui.components"
import { Warning, Info } from "@mui/icons-material"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { ReactSVG } from "react-svg"


import CloseSvg from "../../assets/modeltools/RedXMark.svg"
import ResetSvg from "../../assets/bottomToolBar/stage/reset.svg"

import { resegmentationModule } from "@/gluelayer/core/modules/resegmentation/resegmentationModule"


interface Type {
  ClickClose?:  (e) => void
  DoShowClose?:boolean
}

const SpaceCorrectTools: FC<Type> = ({
  ClickClose,
  DoShowClose
}) => {
  const dispatch = useAppDispatch()
    const theme = useTheme()
 


  return (
<>


<Box  sx={{
                display: 'flex',
                alignItems:"flex-end",
                position: "absolute",
                top: "250px",
                right:"1%",
                width:"130px",
                height:"500px",
                borderRadius: 2,
                flexDirection: 'column',
               
                //bgcolor: theme.transBkColor.light
                
                }}>

<Box sx={{
                display: 'flex',
                right:"2%",
                width:"250px",
                height:"70px",
                borderRadius: 2,
                flexDirection: 'row-reverse',
                alignItems:"center",
                //bgcolor: theme.transBkColor.light
                
                }}>



       {DoShowClose&&(<Box
                sx={{
                  display: 'flex',
                  alignItems:"column",
                  width:"35px",
                  height:"35px",  
                  marginLeft:"20px",
                }}>
          <IconButton
              sx={{
                display: 'flex',
                alignItems:"center",
                width:"35px",
                height:"35px",
                borderRadius: 100,
                backgroundColor:"#FF632B",
                "&:hover": {background: "#FF632B"}
                }} 
                
              onClick={ClickClose}
          >
              <img  src={CloseSvg} style={{height:"18px", width:"18px"}}></img>
          </IconButton>
          </Box>)}

                  
              <Typography variant="h5" color="#FFFFFF">
                Check Space
              </Typography>




</Box>


</Box>


</>
   
  )
}
export default SpaceCorrectTools
